module.exports = __webpack_public_path__ + "img/setup-3.b269e308.png";